import { ImgTimelapse, ImgComparisonSlider } from "@components";
import { virdisGradient } from "@/helpers/constants";


export const hero = {
    bgColor: "blue",
    headerImg:
        "https://viz-assets.ctrees.org/webv3/products/hero/land-carbon-hero.png",
    title: "Land Carbon Map",
    subheader: "Measure carbon in all forest and non-forest land globally",
    desc: "Estimate carbon stocks, emissions, and removals at 1-hectare resolution annually in all forest and non-forest ecosystems on land. Access our aboveground biomass times series, a global dataset for 2000-2025.",
    buttonText: "Access Data via Earthmover",
    productLink: "https://app.earthmover.io/marketplace/69e00e1c21faca8bf36879d2",
};

const s3URI =
    "https://viz-assets.ctrees.org/webv3/products/beats/";

const timelapseImgs = [
    { year: "'15", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2015.png` },
    { year: "'16", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2016.png` },
    { year: "'17", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2017.png` },
    { year: "'18", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2018.png` },
    { year: "'19", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2019.png` },
    { year: "'20", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2020.png` },
    { year: "'21", src: `${s3URI}Land+Carbon+Timelapse/landcarbon_timelapse_2021.png` },
];

const timelapseCoords = { lat: -2.738, lon: -54.800 };
const timelapseCaption =
    "Land carbon loss and recovery following major wildfires in 2016 in the Tapajós region of the Brazilian Amazon";

export const features = [
    {
        title: "Historical accuracy for inventories and baselines",
        img: (
            <ImgTimelapse
                images={timelapseImgs}
                coordinates={timelapseCoords}
                caption={timelapseCaption}
                gradient={{
                    colors: virdisGradient,
                    labelValues: { min: "0", max: ">400" },
                    label: "Aboveground biomass (Mg/ha)"
                }}
            />
        ),
        list: [
            "Access accurate geospatial data at 1-hectare resolution from 2000 to present.",
            "Meet IPCC Tier 3 standards for wall-to-wall mapping, for national greenhouse gas inventories and Paris Agreement nationally determined contributions.",
        ],
    },
    {
        title: "Data for policy and carbon markets",
        bgImg: "https://viz-assets.ctrees.org/webv3/products/beats/land-carbon-beat-2.png",
        list: [
            "Meet accuracy requirements for calculating emission factors at project or jurisdictional levels. ",
            "Establish accurate forest reference emission levels at jurisdiction scales for REDD finance. ",
            "Understand spatial confidence level for prediction of carbon risks and returns.",
        ],
    },
    {
        title: "Comprehensive coverage",
        img: (
            <ImgComparisonSlider
                imgBefore={`${s3URI}Land+Carbon+Slider/landcarbon_left_beat3.png`}
                imgBeforeAlt={"Land carbon map before"}
                imgAfter={`${s3URI}Land+Carbon+Slider/landcarbon_right_beat3.png`}
                imgAfterAlt={"Land carbon map after"}
                gradient={{
                    colors: virdisGradient,
                    labelValues: { min: "0", max: "250" },
                    label: "Aboveground biomass (Mg/ha)"
                }}
                caption="Aboveground biomass mapped at 30m resolution over the border between Mexico and Guatemala"
            />
        ),
        list: [
            "Estimate carbon for all ecosystems on land: forests, woodlands, grasslands, urban areas, croplands, coastal wetlands, and mangroves.",
            "Understand impacts of climate change, soil, and disturbance processes.",
        ],
    },
    {
        title: "Measuring removals",
        bgImg: "https://viz-assets.ctrees.org/webv3/products/beats/land-carbon-beat-4.png",
        list: [
            "Calculate forest recovery and regrowth potential at 1-km resolution in any forest area globally.",
            "Estimate carbon removals by forest age and location for any restoration program.",
        ],
    },
];

export const questionList = [
    {
        question:
            "Understand impacts of climate change, soil, and disturbance processes?",
        answer: "Estimate carbon for all ecosystems on land: forests, woodlands, grasslands, urban areas, croplands, coastal wetlands, and mangroves.",
    },
    {
        question:
            "Access accurate geospatial data at 1-hectare resolution from 2000 to present?",
        answer: "Estimate carbon for all ecosystems on land: forests, woodlands, grasslands, urban areas, croplands, coastal wetlands, and mangroves.",
    },
    {
        question: "Measure carbon in all forest and non-forest land globally?",
        answer: "Estimate carbon for all ecosystems on land: forests, woodlands, grasslands, urban areas, croplands, coastal wetlands, and mangroves.",
    },
];
